module.exports = __webpack_public_path__ + "img/vespa_325.b0cf6398.png";